import type { HoverContentSchema } from '../Common/Hover'
import type { ChecklistItem as BoardChecklistItem } from '../../types/schema'

export const normalizeStars = (value: unknown) => {
  const numeric = typeof value === 'number' && Number.isFinite(value) ? Math.round(value) : 1
  return Math.min(5, Math.max(1, numeric))
}

export const formatCost = (value: number | null | undefined) =>
  typeof value === 'number' && Number.isFinite(value) ? `$${value.toFixed(2)}` : '$0.00'

export function buildChecklistNodeContent(node: BoardChecklistItem, parentPath: string, parentColor: string): HoverContentSchema {
  const kicker = node.isUrgentCrisisMode ? 'URGENT CAPSULE' : 'CHECKLIST CAPSULE'
  const stars = normalizeStars(node.complexityStars)
  const meta = [
    `Path: ${parentPath}`,
    `Created by: ${node.createdByName || 'Workspace admin'}`,
    `Assignee: ${node.assigneeName || 'Unassigned'}`,
    `Status: ${node.workflowStatus ?? (node.isCompleted ? 'COMPLETED' : 'CREATED')}`,
    `Effort ${node.estimatedHours ?? 0}h · Cost ${formatCost(node.actualCost)} · Weight ${'★'.repeat(stars)}${'☆'.repeat(5 - stars)}`,
  ]
  if (node.blockedByNodeIds && node.blockedByNodeIds.length > 0) {
    meta.push(`Blocked by: ${node.blockedByNodeIds.map((link) => link.title).join(', ')}`)
  }
  return {
    kicker,
    title: node.title,
    subtitle: node.description || node.completionCriteria || undefined,
    meta,
    accent: parentColor || undefined,
  }
}

export function buildChecklistWireContent(source: BoardChecklistItem, target: BoardChecklistItem): HoverContentSchema {
  return {
    kicker: 'DEPENDENCY WIRE',
    title: `${source.title} → ${target.title}`,
    subtitle: `BLOCKER: ${source.title} must strike 100% progress to unlock downstream ${target.title}`,
  }
}
